import React from "react";
import { IBoxwithTitleAndInfo } from "./IBoxwithTitleAndInfo";
import { Grid } from "@mui/material";
import "./boxwithTitleAndInfo.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { verifyCustomerInformationResponse } from "../../../models/customer.model";
export default function BoxwithTitleAndInfo({
  dataVerifyCustomer,
}: IBoxwithTitleAndInfo) {
  return (
    <Grid container className="wholeBox">
      <Grid
        xs={12}
        textAlign={"center"}
        className={
          dataVerifyCustomer?.amount! > 0 ? "bgTitle_credit p-3" : "bgTitle p-3"
        }
      >
        {dataVerifyCustomer?.amount! > 0 ? (
          <CheckCircleIcon />
        ) : (
          <WarningRoundedIcon />
        )}{" "}
        {dataVerifyCustomer?.message!}
      </Grid>
      <Grid container xs={12} className="p-8" sx={{ color: "#9AAFC4" }}>
        <Grid xs={4} className="borderLeft">
          <span>نام و نام خانوادگی:</span>
          <span style={{ color: "#34495E" }}>
            &nbsp;{dataVerifyCustomer?.fullName}
          </span>
        </Grid>
        <Grid xs={4} className="borderLeft">
          <span className="px-3">شماره موبایل:</span>
          <span style={{ color: "#34495E" }}>
            {dataVerifyCustomer?.mobileNumber}
          </span>
        </Grid>
        <Grid xs={4}>
          <span className="px-3">مجموع اعتبار (ريال) :</span>
          <span style={{ color: "#34495E" }}>
            {dataVerifyCustomer?.amount.toLocaleString()}
          </span>
        </Grid>
      </Grid>
    </Grid>
  );
}
